import { useQueries } from '@tanstack/react-query';

import type {
  StaffProfileStoresItem,
  StoreProductListItem,
} from '@nucleus-commerce/api-client/admin';

import { session } from '@/shared/session/session';

import { storeMembershipQueryOptions } from './use-store-products';

export interface OtherStore {
  store: StaffProfileStoresItem;
  row: StoreProductListItem;
}

/** The other stores this person can act on that sell the product, each with its publication. */
export function useOtherStores(storeId: string, productId: string): OtherStore[] {
  const { me } = session.useSession();
  const stores = (me?.stores ?? []).filter((store) => store.id !== storeId);
  const memberships = useQueries({
    queries: stores.map((store) => storeMembershipQueryOptions(store.id, productId)),
  });
  return stores.flatMap((store, index) => {
    const row = memberships[index]?.data;
    return row ? [{ store, row }] : [];
  });
}
